import { api } from "./api";
import { mockAdapter } from "./mockAdapter";

const USE_MOCKS = (import.meta.env.VITE_DATA_MODE || "mock") === "mock";

const buildParams = (filters = {}) => ({
  period: filters.period,
  city: filters.city && filters.city !== "todas" ? filters.city : undefined,
  beneficiary_type: filters.beneficiaryType && filters.beneficiaryType !== "todos" ? filters.beneficiaryType : undefined,
  start_date: filters.dateRange?.start || undefined,
  end_date: filters.dateRange?.end || undefined,
});

export const dashboardService = {
  async getOverview(filters) {
    if (USE_MOCKS) return mockAdapter.getOverview();
    const res = await api.get("/dashboard/overview", { params: buildParams(filters) });
    return res.data;
  },
  async getJourney(filters) {
    if (USE_MOCKS) return mockAdapter.getJourney();
    const res = await api.get("/dashboard/journey", { params: buildParams(filters) });
    return res.data;
  },
  async getDrivers(filters) {
    if (USE_MOCKS) return mockAdapter.getDrivers();
    const res = await api.get("/dashboard/drivers", { params: buildParams(filters) });
    return res.data;
  },
  async getVerbatins(filters) {
    if (USE_MOCKS) return mockAdapter.getVerbatins();
    const res = await api.get("/dashboard/verbatins", { params: buildParams(filters) });
    return res.data;
  },
  async getTrends(filters) {
    if (USE_MOCKS) return mockAdapter.getTrends();
    const res = await api.get("/dashboard/trends", { params: buildParams(filters) });
    return res.data;
  },
  async getSegmentation(filters) {
    if (USE_MOCKS) return mockAdapter.getSegmentation();
    const res = await api.get("/dashboard/segmentation", { params: buildParams(filters) });
    return res.data;
  },
  async getBenchmarking(filters) {
    if (USE_MOCKS) return mockAdapter.getBenchmarking();
    const res = await api.get("/dashboard/benchmarking", { params: buildParams(filters) });
    return res.data;
  },
  async getActionPlan(filters) {
    if (USE_MOCKS) return mockAdapter.getActionPlan();
    const res = await api.get("/dashboard/action-plan", { params: buildParams(filters) });
    return res.data;
  },
  async getCooperacao() {
    if (USE_MOCKS) return mockAdapter.getCooperacao();
    const res = await api.get("/cooperacao/feed");
    return res.data;
  },
  async createActionPlan(payload) {
    if (USE_MOCKS) {
      await new Promise((r) => setTimeout(r, 200));
      return { ...payload, id: `acao_${Date.now()}`, status: "Em andamento" };
    }
    const res = await api.post("/dashboard/action-plan", payload);
    return res.data;
  },
  async updateActionPlan(id, payload) {
    if (USE_MOCKS) {
      await new Promise((r) => setTimeout(r, 200));
      return { ...payload, id };
    }
    const res = await api.patch(`/dashboard/action-plan/${id}`, payload);
    return res.data;
  },
  async publishToCooperacao(payload) {
    if (USE_MOCKS) {
      await new Promise((r) => setTimeout(r, 200));
      return { ...payload, id: `coop_${Date.now()}` };
    }
    const res = await api.post("/cooperacao/feed", payload);
    return res.data;
  },
};
